/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'

// eslint-disable-next-line import/prefer-default-export
export const userLoggedSlice = createSlice({
  name: 'user',
  authToken: 'token',
  refreshToken: 'token',
  sessionToken: 'token',
  initialState: {
    name: null,
    authToken: null,
    idToken: null,
    refreshToken: null,
    sessionToken: null,
    userGroups: null,
    role: null,
  },
  reducers: {
    SET_USER_LOGGED: (state, action) => {
      state.name = action.payload.name
      state.authToken = action.payload.authToken
      state.idToken = action.payload.idToken
      state.refreshToken = action.payload.refreshToken
      state.userGroups = action.payload.groups
      state.role = action.payload.role
    },
    SET_USER_CHALLENGED: (state, action) => {
      state.name = action.payload.name
      state.sessionToken = action.payload.sessionToken
    },
    SET_USER_LOGGED_OUT: (state) => {
      state.name = null
      state.authToken = null
      state.idToken = null
      state.refreshToken = null
      state.sessionToken = null
      state.userGroups = null
    },
    SET_REFRESHED_AUTH_TOKEN: (state, action) => {
      state.authToken = action.payload.authToken
      state.idToken = action.payload.idToken
      state.userGroups = action.payload.groups
    },
  },
})

export const {
  SET_USER_LOGGED,
  SET_USER_LOGGED_OUT,
  SET_USER_CHALLENGED,
  SET_REFRESHED_AUTH_TOKEN,
} = userLoggedSlice.actions
export const loggedUser = (state) => state.user

/* In order to get the data from the current user you ought to
import useSelector and loggedUser. Once done the previous assign as per shown below:

let data = useSelector(loggedUser)

You will get both the username and authToken as an object

*/

export default userLoggedSlice.reducer
